/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

(function ($, TweenMax, enquire) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Roots = {

    // All pages
    common: {
      init: function () {
        /*
        // JavaScript to be fired on all pages
        if (!Modernizr.svg) {
          $('img[src$=".svg"]').each(function() {
            var $this = $(this); // this = img
            $this.attr('src', $this.attr('src').replace(/svg$/, 'png'));
          });
        }
        */

        /**
         * Enabled the colorbox jquery modal and dont go to the next page
         */

         $('.cboxElement').on('click', e => {
            e.preventDefault();
        });
        $('.cboxElement').colorbox();

        var sticky_navigation = function () {
          var scroll_top = $(window).scrollTop(); // our current vertical position from the top

          if (scroll_top > 100) {
            $('#sticky_navigation').fadeIn(500);
          } else {
            $('#sticky_navigation').fadeOut('fast');
          }

        };

        // run our function on load
        sticky_navigation();

        // and run it again every time you scroll
        $(window).on( "scroll", (function () {
          sticky_navigation();
        }));


        $(".toggle-menu").click(function (e) {
          e.preventDefault();
          $("#mobile-nav").slideToggle();
        });
        $(".close-menu").click(function () {
          $("#mobile-nav").slideToggle();
        });

        $(window).resize(function () {
          if ($(window).width() > 992) {
            $("#mobile-nav").hide();
          }
        });

        if (document.querySelector('#home-video-fullscreen') && document.querySelector('#home-video-loop')) {
          var fullscreenPlayer = videojs("home-video-fullscreen");
          var loopPlayer = videojs("home-video-loop");
          loopPlayer.muted();
          $("#play-video").click(function () {
            $("#home-video-fullscreen").show();
            $("#home-video-fullscreen video").show();
            $("#home-video-loop").hide();
            $(".video-overlay").hide();
            loopPlayer.pause();
            fullscreenPlayer.requestFullscreen();
            fullscreenPlayer.muted(false);
            fullscreenPlayer.play();
          });
  
          $('#home-video-fullscreen video').bind('ended', function () {
            fullscreenPlayer.exitFullscreen();
            $("#home-video-fullscreen").hide();
            $("#home-video-loop").show();
            $(".video-overlay").show();
            loopPlayer.play();
          });
        }

        /*if(!$.cookie("notification-inactive")) {
          setTimeout(function(){
            $('.notification-inactive').slideToggle(800);
          }, 500);
        }
  
        if(!$.cookie("notification-outside")) {
          setTimeout(function(){
            $('.notification-outside').slideToggle(800);
          }, 500);
        }*/

        $('.notifications .btn-close').click(function (evt) {
          $('.notifications').slideToggle("fast");

          // notification-inactie cookie was never set. Fixed
          if ($(this).parent().hasClass('notification-outside')) {
            Cookies.set('notification-outside', 1, {expires: 30, path: '/'});
          } else {
            Cookies.set("notification-inactive", 1, { expires: 30, path: "/" });
          }
        });

        $('img.svg').each(function () {
          var $img = $(this);
          var imgID = $img.attr('id');
          var imgClass = $img.attr('class');
          var imgURL = $img.attr('src');

          jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var $svg = $(data).find('svg');

            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
              $svg = $svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
              $svg = $svg.attr('class', imgClass + ' replaced-svg');
            }

            // Remove any invalid XML tags as per http://validator.w3.org
            $svg = $svg.removeAttr('xmlns:a');
            // Replace image with new SVG
            $img.replaceWith($svg);

          }, 'xml');

        });




        var loaderContainer = '<div class="loading"><div class="spinner"><div class="mask"><div class="maskedCircle"></div></div></div></div>',
          selectSet = $('.region-autoload, .schoolboard-autoload, .school-autoload'),
          containerSet = $('.region-select, .schoolboard-select, .school-select');

        selectSet.change(function () {
          var $el = $(this),
            otherEls = containerSet.not($el.parent());

          // Load fields that have not been actively changed on each value change.
          otherEls.hide();
          $(loaderContainer).insertAfter(otherEls);

          $('button.first-step.next').attr("disabled", "disabled");

          // Validate selected data server-side.
          $.ajax({
            url: WpConfig.ajaxurl,
            method: 'POST',
            data: {
              action: 'schoolfilterchange',
              security: WpConfig.security,
              region: $('.region-autoload').val(),
              schoolboard: $('.schoolboard-autoload').val(),
              school: $('.school-autoload').val(),
              trigger: $el.attr('name')
            },
            dataType: 'json'
          }).done(function (data) {
            $('.loading').remove();
            containerSet.show();
            $('button.first-step.next').attr("disabled", null);

            var options = "";
            var i = 0;
            // When a set of data is passed, populate the selectbox
            if (data.regions.length > 0) {
              options = "";
              for (i = 0, len = data.regions.length; i < len; i++) {
                options += '<option value="' + data.regions[i].value + '">' + data.regions[i].label + '</option>';
              }
              $('select.region-autoload').html(options);
            }

            if (data.schoolboards.length > 0) {
              options = "";
              for (i = 0, len = data.schoolboards.length; i < len; i++) {
                options += '<option value="' + data.schoolboards[i].value + '">' + data.schoolboards[i].label + '</option>';
              }
              $('select.schoolboard-autoload').html(options);
            }

            if (data.schools.length > 0) {
              options = "";
              for (i = 0, len = data.schools.length; i < len; i++) {
                options += '<option value="' + data.schools[i].value + '">' + data.schools[i].label + '</option>';
              }
              $('select.school-autoload').html(options);
            }

            // When an explicit value is passed, ensure that is what is selected.
            if (data.region_id) {
              $('select.region-autoload').val(data.region_id + "");
            } else {
              $('select.region-autoload').val($('select.region-autoload option:first-child').attr("value"));
            }

            if (data.schoolboard_id) {
              $('select.schoolboard-autoload').val(data.schoolboard_id + "");
            } else {
              $('select.schoolboard-autoload').val($('select.schoolboard-autoload option:first-child').attr("value"));
            }

            if (data.school_id) {
              $('select.school-autoload').val(data.school_id + "");
            } else {
              $('select.school-autoload').val($('select.school-autoload option:first-child').attr("value"));
            }
          });

        });

        $("input.phone.area").keyup(function () {
          if (this.value.length == this.maxLength) {
            $("input.phone.office").focus();
          }
        });
        $("input.phone.office").keyup(function () {
          if (this.value.length == this.maxLength) {
            $("input.phone.station").focus();
          }
        });
        $("input.phone.station").keyup(function () {
          if (this.value.length == this.maxLength) {
            $("input.phone.ext").focus();
          }
        });
      }
    },
    /* SCHOOL LIST */
    page_template_template_school_list_php: {
      init: function () {
        window.ajaxRequest = null;
        $.ajax({
          url: WpConfig.ajaxurl,
          method: 'POST',
          dataType: "json",
          data: {
            action: 'activeregions',
            //security: WpConfig.security
          }
        }).done(function (activeRegions) {

          $("#regions").find('g').each(function () {
            var elID = $(this).attr('id');
            if (activeRegions[elID]) {
              $(this).attr('class', 'hasItems');
            }
          });
          $('#regions .hasItems').click(function (evt) {
            var elID = $(this).attr('id');
            var dataID = $('.regions-list li.' + elID).attr('data-id');
            var linkURL = $('.regions-list li.' + elID).find("a").attr('data-href');
            getRegionData(elID, dataID);
            //history.pushState({}, '', linkURL);
            $('body, html').scrollTo(440);
            evt.preventDefault();
          });

          $('#regions .hasItems').hover(function () {
            var elID = $(this).attr('id');
            var pos = $(this).find('text').offset();
            var tooltip = $(".tooltip");
            tooltip.find(".content-text").html(activeRegions[elID]);

            var tooltipPositions = {
              "region-1": { "x": 222, "y": 310 },
              "region-2": { "x": 128, "y": 275 },
              "region-3": { "x": 196, "y": 353 },
              "region-4": { "x": 154, "y": 362 },
              "region-5": { "x": 215, "y": 412 },
              "region-6": { "x": 368, "y": 378 },
              "region-7": { "x": 87, "y": 407 },
              "region-8": { "x": 21, "y": 346 },
              "region-9": { "x": 215, "y": 213 },
              "region-10": { "x": 53, "y": 153 },
              "region-11": { "x": 260, "y": 250 },
              "region-12": { "x": 176, "y": 355 },
              "region-13": { "x": 368, "y": 362 },
              "region-14": { "x": 142, "y": 394 },
              "region-15": { "x": 113, "y": 397 },
              "region-16": { "x": 164, "y": 426 },
              "region-17": { "x": 153, "y": 397 },
            };


            tooltip.css("top", tooltipPositions[elID].y);
            tooltip.css("left", tooltipPositions[elID].x);

            tooltip.stop().animate({
              opacity: 1,
              top: "+=20"
            }, 400);
          },
            function () {
              $(".tooltip").stop().css("opacity", 0);
            });
        });


        $('.regions-list li a').click(function (evt) {
          var elID = $(this).parent('li').attr('rel');
          var dataID = $('.regions-list li.' + elID).attr('data-id');
          getRegionData(elID, dataID);
          //history.pushState({}, '', evt.target.href);
          $('body, html').scrollTo(440);
          evt.preventDefault();
        });

        $('.region-select select').change(function (evt) {
          var elID = $(this).val();
          var dataID = $('.regions-list li.' + elID).attr('data-id');
          var linkURL = $('.regions-list li.' + elID).find("a").attr('data-href');
          getRegionData(elID, dataID);
          //history.pushState({}, '', linkURL);
          evt.preventDefault();
        });

        $(".view-regions").click(function () {
          $('body, html').scrollTo(440);
        });

        selectRegion($('*[data-active=1]').attr("rel"));


        function getRegionData(regionID, dataID) {
          selectRegion(regionID);
          if (window.ajaxRequest != null) {
            window.ajaxRequest.abort();
          }
          $(".region-content").slideUp("fast");
          $(".loading").remove();
          var loaderContainer = $('<div class="loading"><div class="spinner"><div class="mask"><div class="maskedCircle"></div></div></div></div>').insertAfter($(".region-content"));

          window.ajaxRequest = $.ajax({
            url: WpConfig.ajaxurl,
            method: 'POST',
            data: {
              action: 'schoolsbyregion',
              security: WpConfig.security,
              region: parseInt(dataID, 10)
            }
          }).done(function (data) {
            loaderContainer.remove();
            $(".region-content").html(data).slideDown('slow');
            window.ajaxRequest = null;
          });


        }
        function selectRegion(regionID) {
          $('#regions .active').attr('class', 'hasItems');

          if ($("#" + regionID).attr('class') == 'hasItems') {
            $("#" + regionID).attr('class', 'hasItems active');
          }
          $('.region-select select').val(regionID);
          $('.regions-list li.active').removeClass('active');
          $('.regions-list li.' + regionID).addClass('active');
        }
      }
    },
    page_template_template_forms_php: {
      init: function () {

        //console.log('on page template forms');

        function onRemove(event) {
          event.preventDefault();
          $(this).parents('.child').remove();
        }

        if ($('.forms-stepbar').length) {
          $('.forms-header').addClass('has-stepbar');
        }

        if ($('.intergeneration-form_wrapper').length) {
          $('body').addClass('has-intergeneration-form');
        }

        $('a.remove-child').click(onRemove);
        $('a.duplicate-child').click(function (event) {
          event.preventDefault();

          var lastRow = $('div[data-children-idx]').last(),
            html = lastRow.clone().html(),//lastRow.html(),
            prevIdx = parseInt(lastRow.attr("data-children-idx"), 10),
            replaceUnderscores = new RegExp("_" + prevIdx + "_", 'g'),
            replaceBrakets = new RegExp("\\[children\\]\\[" + prevIdx + "\\]", 'g'),
            added;

          html = html.replace(replaceUnderscores, "_" + (prevIdx + 1) + "_").replace(replaceBrakets, "[children][" + (prevIdx + 1) + "]");
          added = $('<div class="child" data-children-idx="' + (prevIdx + 1) + '">' + html + '</div>');
          added.unbind();

          lastRow.after(added);
          added.find('.row.remove-children').show();
          added.find('a.remove-child').click(onRemove);

          //Clear fields for IE
          added.find("input[type=text], textarea").each(function () {
            $(this).val("");
          });
          added.find("input[type=checkbox], input[type=radio]").each(function () {
            $(this).removeAttr("checked");
          });

        });

        if (window.location.hash) {
          $('body, html').scrollTo(300);
        }

        // prevent multiple form submissions
        $('form').on('submit', function (e) {
          var $form = $(this);

          if ($form.data('submitted') === true) {
            e.preventDefault();
          } else {
            $form.data('submitted', true);
          }
        });

      }
    },
    page_template_template_faq: {
      init: function() {
        // Script comming from old website `faq.js`
        var MqM = 768,
          MqL = 1024;

        var faqsSections = $('.cd-faq-group'),
          faqTrigger = $('.cd-faq-trigger'),
          faqsContainer = $('.cd-faq-items'),
          faqsCategoriesContainer = $('.cd-faq-categories'),
          faqsCategories = faqsCategoriesContainer.find('a'),
          closeFaqsContainer = $('.cd-close-panel');

        //select a faq section 
        faqsCategories.on('click', function (event) {
          event.preventDefault();
          var selectedHref = $(this).attr('href'),
            target = $(selectedHref);
          if ($(window).width() < MqM) {
            faqsContainer.scrollTop(0).addClass('slide-in').children('ul').removeClass('selected').end().children(selectedHref).addClass('selected');
            closeFaqsContainer.addClass('move-left');
            $('body').addClass('cd-overlay');
          } else {
            var top = target.offset().top - 150;
            console.log(top);
            $('body,html').animate({ 'scrollTop': top }, 200);
          }
        });

        //close faq lateral panel - mobile only
        $('body').bind('click touchstart', function (event) {
          if ($(event.target).is('body.cd-overlay') || $(event.target).is('.cd-close-panel')) {
            closePanel(event);
          }
        });
        faqsContainer.on('swiperight', function (event) {
          closePanel(event);
        });

        //show faq content clicking on faqTrigger
        faqTrigger.on('click', function (event) {
          event.preventDefault();
          $(this).next('.cd-faq-content').slideToggle(200).end().parent('li').toggleClass('content-visible');
        });

        //update category sidebar while scrolling
        $(window).on('scroll', function () {
          if ($(window).width() > MqL) {
            if (!window.requestAnimationFrame) {
              updateCategory();
            } else {
              window.requestAnimationFrame(updateCategory);
            }
          }
        });

        $(window).on('resize', function () {
          if ($(window).width() <= MqL) {
            faqsCategoriesContainer.removeClass('is-fixed').css({
              'transform': 'translateY(0)',
            });
          }
          if (faqsCategoriesContainer.hasClass('is-fixed')) {
            faqsCategoriesContainer.css({
              'left': faqsContainer.offset().left,
            });
          }
        });

        function closePanel(e) {
          e.preventDefault();
          faqsContainer.removeClass('slide-in').find('li').show();
          closeFaqsContainer.removeClass('move-left');
          $('body').removeClass('cd-overlay');
        }

        function updateCategory() {
          updateCategoryPosition();
          updateSelectedCategory();
        }

        function updateCategoryPosition() {
          var top = $('.cd-faq').offset().top,
            height = jQuery('.cd-faq').height() - jQuery('.cd-faq-categories').height(),
            margin = 150;
          if (top - margin <= $(window).scrollTop() && top - margin + height > $(window).scrollTop()) {
            var leftValue = faqsCategoriesContainer.offset().left,
              widthValue = faqsCategoriesContainer.width();
            faqsCategoriesContainer.addClass('is-fixed').css({
              'left': leftValue,
              'top': margin,
              'transform': 'translateZ(0)',
            });
          } else if (top - margin + height <= $(window).scrollTop()) {
            var delta = top - margin + height - $(window).scrollTop();
            faqsCategoriesContainer.css({
              'transform': 'translateZ(0) translateY(' + delta + 'px)',
            });
          } else {
            faqsCategoriesContainer.removeClass('is-fixed').css({
              'left': 0,
              'top': 0,
            });
          }
        }

        function updateSelectedCategory() {
          faqsSections.each(function () {
            var actual = $(this),
              margin = parseInt($('.cd-faq-title').eq(1).css('marginTop').replace('px', '')),
              activeCategory = $('.cd-faq-categories a[href="#' + actual.attr('id') + '"]'),
              topSection = (activeCategory.parent('li').is(':first-child')) ? 0 : Math.round(actual.offset().top);

            if ((topSection - 160 <= $(window).scrollTop()) && (Math.round(actual.offset().top) + actual.height() + margin - 160 > $(window).scrollTop())) {
              activeCategory.addClass('selected');
            } else {
              activeCategory.removeClass('selected');
            }
          });
        }
      }
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page

        var fullscreenPlayer = videojs("home-video-fullscreen");
        var loopPlayer = videojs("home-video-loop");
        loopPlayer.muted();
        $("#play-video").click(function () {
          $("#home-video-fullscreen").show();
          $("#home-video-fullscreen video").show();
          $("#home-video-loop").hide();
          $(".video-overlay").hide();
          loopPlayer.pause();
          fullscreenPlayer.requestFullscreen();
          fullscreenPlayer.muted(false);
          fullscreenPlayer.play();
        });

        $('#home-video-fullscreen video').bind('ended', function () {
          fullscreenPlayer.exitFullscreen();
          $("#home-video-fullscreen").hide();
          $("#home-video-loop").show();
          $(".video-overlay").show();
          loopPlayer.play();
        });


        var tlPaws_01 = new TimelineMax();
        var i,
          dot,
          quantity = 5, //number of dots
          duration = 2,
          path = [{ x: 120, y: -60 }, { x: 150, y: 10 }, { x: 250, y: 10 }, { x: 270, y: 30 }],
          position = { x: path[0].x, y: [path[0].y] },
          tween = TweenMax.to(position, quantity,
            {
              bezier:
              {
                values: path,
                curviness: 1.5,
                autoRotate: 65
              },
              ease: Linear.easeNone
            });

        var posX = 0;
        var posY = 0;
        var rotate = 0;

        for (i = 0; i <= quantity; i++) {
          tween.time(i);

          posX = position.x + (i * 10);
          posY = position.y + (i * 10);
          dot = $("<div />", { id: "dot-01" + i }).addClass("dot").css({ left: posX + "px", top: posY + "px" }).appendTo(".paws");

          rotate = (i == 0) ? -130 : position.rotation;
          tlPaws_01.set(dot, { visibility: "visible", rotation: rotate }, i * (duration / quantity));
        }

        var set01_quantity = quantity;

        var tlPaws_02 = new TimelineMax();
        quantity = 3; //number of dots
          duration = 1;
          path = [{ x: 100, y: 500 }, { x: 20, y: 525 }, { x: 30, y: 550 }];
          position = { x: path[0].x, y: [path[0].y] };
          tween = TweenMax.to(position, quantity,
            {
              bezier:
              {
                values: path,
                curviness: 1.5,
                autoRotate: 65
              },
              ease: Linear.easeNone
            });

        posX = 0;
        posY = 0;
        rotate = 0;
        var set02_quantity = 0;

        for (i = 0; i <= quantity; i++) {
          tween.time(i);
          set02_quantity = i + (set01_quantity + 1);
          posX = position.x + (i * 10);
          posY = position.y + (i * 10);
          dot = $("<div />", { id: "dot-02-" + set02_quantity }).addClass("dot").css({ left: posX + "px", top: posY + "px" }).appendTo(".paws");

          rotate = (i == 0) ? -130 : position.rotation;
          tlPaws_02.set(dot, { visibility: "visible", rotation: rotate }, i * (duration / quantity));
        }


        var tlPaws_03 = new TimelineMax();
        i = 0;
        dot = 0;
          quantity = 17; //number of dots
          duration = 2;
          path = [{ x: 490, y: 1400 }, { x: 605, y: 1500 }, { x: 870, y: 1605 }, { x: 570, y: 1740 }];
          position = { x: path[0].x, y: [path[0].y] };
          tween = TweenMax.to(position, quantity,
            {
              bezier:
              {
                values: path,
                curviness: 1.5,
                autoRotate: 65
              },
              ease: Linear.easeNone
            });
        var set03_quantity = 0;
        for (i = 0; i <= quantity; i++) {
          tween.time(i);
          set03_quantity = i + (set02_quantity + 1);

          posX = position.x + (i * 10);
          posY = position.y + (i * 10);
          dot = $("<div />", { id: "dot-03" + set03_quantity }).addClass("dot").css({ left: posX + "px", top: posY + "px" }).appendTo(".paws");

          rotate = (i == 0) ? -130 : position.rotation;

          tlPaws_03.set(dot, { visibility: "visible", rotation: rotate }, i * (duration / quantity));
        }


        var set04_quantity = 0;
        var tlPaws_04 = new TimelineMax();
        i = 0;
        dot = 0;
        quantity = 8; //number of dots
        duration = 2;
        path = [{ x: 230, y: 2120 }, { x: 30, y: 2260 }, { x: 70, y: 2330 }];
        position = { x: path[0].x, y: [path[0].y] };
        tween = TweenMax.to(position, quantity,
          {
            bezier:
            {
              values: path,
              curviness: 1.5,
              autoRotate: 65
            },
            ease: Linear.easeNone
          });

        for (i = 0; i <= quantity; i++) {
          tween.time(i);
          set04_quantity = i + (set03_quantity + 1);
          posX = position.x + (i * 10);
          posY = position.y + (i * 10);
          dot = $("<div />", { id: "dot-04" + set04_quantity }).addClass("dot").css({ left: posX + "px", top: posY + "px" }).appendTo(".paws");

          rotate = (i == 0) ? -130 : position.rotation;

          tlPaws_04.set(dot, { visibility: "visible", rotation: rotate }, i * (duration / quantity));
        }



        // init controller
        var controller = new ScrollMagic.Controller();

        // build scene
        var scene = new ScrollMagic.Scene({ triggerElement: '#trigger-01', duration: 450, offset: -100, reverse: false })
          .setTween(tlPaws_01)
          .addTo(controller);

        scene = new ScrollMagic.Scene({ triggerElement: "#trigger-02", duration: 200, offset: -190, reverse: false })
          .setTween(tlPaws_02)
          .addTo(controller);

        scene = new ScrollMagic.Scene({ triggerElement: "#trigger-03", duration: 650, offset: 170, reverse: false })
          .setTween(tlPaws_03)
          .addTo(controller);

        scene = new ScrollMagic.Scene({ triggerElement: "#trigger-04", duration: 300, offset: 170, reverse: false })
          .setTween(tlPaws_04)
          .addTo(controller);

        // News Card Behavior
        $('.flip-card').on('mouseover', function(){
          $('.flip-card').removeClass('hover');
        });

        // News Card Behavior
        $('.flip-card').on('mouseout', function(){
          $('.flip-container:first .flip-card').addClass('hover');
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var namespace = Roots;
      funcname = (funcname === undefined) ? 'init' : funcname;
      if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
      });
    }
  };

  $(function() {
    UTIL.loadEvents();
  });

})(jQuery, TweenMax, enquire); // Fully reference jQuery after this point.

jQuery.fn.scrollTo = function (target, options, callback) {
  var $ = jQuery;
  if (typeof options == 'function' && arguments.length == 2) { callback = options; options = target; }
  var settings = $.extend({
    scrollTarget: target,
    offsetTop: 50,
    duration: 500,
    easing: 'swing'
  }, options);
  return this.each(function () {
    var scrollPane = $(this);
    var scrollTarget = (typeof settings.scrollTarget == "number") ? settings.scrollTarget : $(settings.scrollTarget);
    var scrollY = (typeof scrollTarget == "number") ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop);
    scrollPane.animate({ scrollTop: scrollY }, parseInt(settings.duration), settings.easing, function () {
      if (typeof callback == 'function') { callback.call(this); }
    });
  });
};
